module.exports = __webpack_public_path__ + "img/bestIcon.4feeb4b4.svg";